export default {
  title: {
    en: 'Over 700 fragrances (and counting!) are waiting for you',
  },
}
